import { jsx as _jsx } from "react/jsx-runtime";
import styled, { mediaQuery, css } from '../../utils/Styling';
import UICardGrid from 'UIComponents/card/UICardGrid';
const StyledCardGrid = styled(UICardGrid).withConfig({
  displayName: "TrackRecommendationsGrid__StyledCardGrid",
  componentId: "sc-1s6i1jv-0"
})(["grid-template-columns:1fr;", ""], mediaQuery('desktop', css(["grid-template-columns:repeat(3,1fr);"])));

const TrackRecommendationsGrid = ({
  children
}) => {
  return /*#__PURE__*/_jsx(StyledCardGrid, {
    gutterSize: 24,
    children: children
  });
};

export default TrackRecommendationsGrid;